<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2L14.5 7.66987L20.6603 7L17 12L20.6603 17L14.5 16.3301L12 22L9.5 16.3301L3.33975 17L7 12L3.33975 7L9.5 7.66987L12 2Z"
      fill="currentColor"
    />
  </svg>
</template>
